"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Main = void 0;
const styles_1 = require("@mui/material/styles");
const Main = (0, styles_1.styled)('main', {
    shouldForwardProp: (prop) => prop !== 'open' || 'drawerWidth' || 'anchor',
})(({ theme, open, drawerWidth, anchor }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    marginRight: anchor === 'right' ? -drawerWidth : '',
    marginLeft: anchor === 'left' ? `-${drawerWidth}px` : '',
    position: anchor === 'right' ? 'relative' : 'static',
    variants: [
        {
            props: open,
            style: {
                transition: theme.transitions.create('margin', {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.enteringScreen,
                }),
                marginRight: anchor === 'right' && open ? 0 : '',
                marginLeft: anchor === 'left' && open ? 0 : '',
            },
        },
    ],
}));
exports.Main = Main;
//# sourceMappingURL=Main.js.map